import modelFieldMessages from './modelFieldMessages';
import mainUtilsConfig from './utilsConfig';
import { Select, MenuItem, FormControl, InputLabel, Typography, Button } from '@mui/material';
import { sendToWs } from '../../app/containers/Websocket/actions';
import { backendCall } from '../../app/containers/TableView/actions';
import _ from 'lodash';

class lengthsQuality {
  static fields = {
    quality: {
      key: 'quality',
      type: 'string',
      title: modelFieldMessages.quality
    },
    lamellaLength: {
      key: 'lamellaLength',
      type: 'string',
      title: modelFieldMessages.lamellaLength
    },
    lengthMiddleCut1: {
      key: 'lengthMiddleCut1',
      type: 'string',
      title: modelFieldMessages.lengthMiddleCut1
    },
    lamellaWidth: {
      key: 'lamellaWidth',
      type: 'string',
      title: modelFieldMessages.lamellaWidth
    },
    lamellaThickness: {
      key: 'lamellaThickness',
      type: 'string',
      title: modelFieldMessages.lamellaThickness
    },
    lengthMiddleCut2: {
      key: 'lengthMiddleCut2',
      type: 'string',
      title: modelFieldMessages.lengthMiddleCut2
    },
    lamellaClass: {
      key: 'lamellaClass',
      type: 'string',
      choices: [
        { id: 'lamellaClass.I-III', defaultMessage: 'I-III' },
        { id: 'lamellaClass.III-V', defaultMessage: 'III-V' },
        { id: 'lamellaClass.VI', defaultMessage: 'VI' },
        { id: 'lamellaClass.0-V', defaultMessage: '0-V' },
        { id: 'lamellaClass.Radial', defaultMessage: 'Radial' }
      ],
      title: modelFieldMessages.lamellaClass
    },
    wrapping: {
      key: 'wrapping',
      type: 'string',
      choices: [
        { id: 'wrapping.Solis-velika', defaultMessage: 'Solis-velika' },
        { id: 'wrapping.Solis-mala', defaultMessage: 'Solis-mala' },
        { id: 'wrapping.Nevtralna', defaultMessage: 'Nevtralna' },
        { id: 'wrapping.Dobaviteljeva', defaultMessage: 'Dobaviteljeva' },
        { id: 'wrapping.Brez', defaultMessage: 'Brez' }
      ],
      title: modelFieldMessages.wrapping
    },
    numberOfLayers: {
      key: 'numberOfLayers',
      type: 'number',
      title: modelFieldMessages.numberOfLayers
    },
    numOfLamellas: {
      key: 'numOfLamellas',
      type: 'string',
      title: modelFieldMessages.numOfLamellas
    },
    moscaNumberOfLayers: {
      key: 'moscaNumberOfLayers',
      type: 'string',
      title: modelFieldMessages.moscaNumberOfLayers
    },
    moscaNumOfLamellas: {
      key: 'moscaNumOfLamellas',
      type: 'string',
      title: modelFieldMessages.moscaNumOfLamellas
    },
    lengthHeadCut: {
      key: 'lengthHeadCut',
      type: 'string',
      title: modelFieldMessages.lengthHeadCut
    }
  };
}

class sortedOutput {
  static fields = {
    articleNumber: {
      key: 'articleNumber',
      type: 'string',
      title: modelFieldMessages.articleNumber
    },
    lengthPrecision: {
      key: 'lengthPrecision',
      type: 'string',
      title: modelFieldMessages.lengthPrecision
    },
    unitOfMeasure: {
      key: 'unitOfMeasure',
      type: 'string',
      title: modelFieldMessages.unitOfMeasure
    },
    quality: {
      key: 'quality',
      type: 'string',
      title: modelFieldMessages.quality
    },
    isBundle: {
      key: 'isBundle',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.bundle
    },
    piecesPerLayer: {
      key: 'piecesPerLayer',
      type: 'string',
      title: modelFieldMessages.piecesPerLayer
    },
    layers: {
      key: 'layers',
      type: 'string',
      title: modelFieldMessages.layers
    },
    numberOfLayers: {
      key: 'numberOfLayers',
      type: 'string',
      blank: true,
      default: '0',
      title: modelFieldMessages.numberOfLayers
    },
    stickLayerSeq: {
      key: 'stickLayerSeq',
      type: 'string',
      blank: true,
      default: '0',
      title: modelFieldMessages.stickLayerSeq
    },
    stickSpacing: {
      key: 'stickSpacing',
      type: 'string',
      title: modelFieldMessages.stickSpacing
    },
    withFromm: {
      key: 'withFromm',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.withFromm
    },
    withFromm_1: {
      key: 'withFromm',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.withFromm1
    },
    frommTopCorner: {
      key: 'frommTopCorner',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.frommTopCorner
    },
    fromm3TopCorner: {
      key: 'fromm3TopCorner',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.fromm3TopCorner
    },
    frommBottomCorner: {
      key: 'frommBottomCorner',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.frommBottomCorner
    },
    frommFilmInput: {
      key: 'frommFilmInput',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.frommFilmInput
    },
    frommFilmOutput: {
      key: 'frommFilmOutput',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.frommFilmOutput
    },
    withFromm2: {
      key: 'withFromm2',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.withFromm2
    },
    withFromm3: {
      key: 'withFromm3',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.withFromm3
    }
  };
}

class ShoePosition {
  static fields = {
    angle: {
      key: 'angle',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.angle
    },
    position: {
      key: 'position',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.position
    }
  };
}

class BSHOrder {
  static packageTypeChoices = {
    Q: modelFieldMessages.qPackageType,
    L: modelFieldMessages.lPackageType
  };

  static productChoices = {
    0: modelFieldMessages.brunoKVH,
    1: modelFieldMessages.brunoLohnzinken,
    2: modelFieldMessages.brunoAusschhuss
  };

  static lineRegimeChoices = {
    0: modelFieldMessages.bypass,
    1: modelFieldMessages.bypassSmarty,
    2: modelFieldMessages.splitcut,
    3: modelFieldMessages.multiplanSmarty,
    4: modelFieldMessages.splitcutBypass
  };

  static fields = {
    dynamicCheckBox: {
      key: 'check',
      format: {
        type: 'dynamicCheckbox',
        enableFunction: function (item, checkedItems) {
          if (_.get(item, 'status', 'confirmed').includes('unconfirmed')) {
            return true;
          }

          return false;
        }
      }
    },
    draggableArea: {
      key: 'dragHandle',
      format: {
        type: 'dragHandle'
      },
      title: {
        id: 'app.bshOrder.dragHandle',
        defaultMessage: 'Move'
      }
    },
    group: {
      key: 'group',
      title: modelFieldMessages.group,
      format: {
        type: 'object',
        str: '{id}',
        defaultStr: '',
        keys: ['id']
      }
    },
    lengthsQualityData: {
      key: 'lengthsQuality',
      type: 'ListViewAdd',
      format: [
        lengthsQuality.fields.quality,
        lengthsQuality.fields.lamellaLength,
        lengthsQuality.fields.lamellaThickness,
        lengthsQuality.fields.lamellaWidth,
        lengthsQuality.fields.lengthMiddleCut1,
        lengthsQuality.fields.lengthMiddleCut2,
        lengthsQuality.fields.lamellaClass,
        lengthsQuality.fields.numberOfLayers,
        lengthsQuality.fields.numOfLamellas,
        lengthsQuality.fields.moscaNumberOfLayers,
        lengthsQuality.fields.moscaNumOfLamellas,
        lengthsQuality.fields.lengthHeadCut,
        lengthsQuality.fields.wrapping
      ],
      title: modelFieldMessages.lengthQualityData
    },
    sortedOutputFields: {
      key: 'sorted_output',
      type: 'ListViewAdd',
      // label: modelFieldMessages.sortedOutputData,
      format: [
        sortedOutput.fields.articleNumber,
        sortedOutput.fields.lengthPrecision,
        sortedOutput.fields.unitOfMeasure,
        sortedOutput.fields.quality,
        sortedOutput.fields.piecesPerLayer,
        sortedOutput.fields.layers,
        sortedOutput.fields.stickSpacing
      ],
      title: modelFieldMessages.sortedOutputData
    },
    sortedOutputFieldsFournier: {
      key: 'sorted_output',
      type: 'ListViewAdd',
      // label: modelFieldMessages.sortedOutputData,
      format: [
        sortedOutput.fields.articleNumber,
        // sortedOutput.fields.lengthPrecision,
        // sortedOutput.fields.unitOfMeasure,
        sortedOutput.fields.quality
        // sortedOutput.fields.layers
        // sortedOutput.fields.stickSpacing
      ],
      title: modelFieldMessages.sortedOutputData
    },
    sortedOutputFieldsVudlande: {
      key: 'sorted_output',
      type: 'ListViewAdd',
      // label: modelFieldMessages.sortedOutputData,
      format: [
        sortedOutput.fields.articleNumber,
        sortedOutput.fields.quality,
        sortedOutput.fields.isBundle,
        sortedOutput.fields.withFromm_1,
        sortedOutput.fields.frommTopCorner,
        sortedOutput.fields.frommBottomCorner,
        sortedOutput.fields.withFromm2,
        sortedOutput.fields.frommFilmInput,
        sortedOutput.fields.frommFilmOutput,
        sortedOutput.fields.withFromm3,
        sortedOutput.fields.fromm3TopCorner,
        sortedOutput.fields.numberOfLayers,
        sortedOutput.fields.stickLayerSeq
      ],
      title: modelFieldMessages.sortedOutputData
    },
    sortedOutputFieldsWiehag: {
      key: 'sorted_output',
      type: 'ListViewAdd',
      // label: modelFieldMessages.sortedOutputData,
      format: [
        sortedOutput.fields.articleNumber,
        sortedOutput.fields.quality
        //  sortedOutput.fields.isBundle,
        // sortedOutput.fields.withFromm,
        //  sortedOutput.fields.frommTopCorner,
        //  sortedOutput.fields.frommBottomCorner,
        //  sortedOutput.fields.withFromm2,
        //  sortedOutput.fields.frommFilmInput,
        //  sortedOutput.fields.frommFilmOutput,
        //  sortedOutput.fields.withFromm3,
        //  sortedOutput.fields.fromm3TopCorner
      ],
      title: modelFieldMessages.sortedOutputData
    },
    bshorderColor: {
      key: 'orderColor',
      type: 'string',
      format: {
        type: 'color'
      }
    },
    layers: {
      key: 'layers',
      type: 'foreignkey',
      title: modelFieldMessages.layers
    },
    combinedOrderColor: {
      key: 'combinedColors',
      type: 'string',
      format: {
        type: 'combinedColor'
      }
    },
    totalCubicMeters: {
      key: 'totalCubicMeters',
      type: 'string',
      title: modelFieldMessages.cubicMeter
    },
    opBlockNumber: {
      key: 'number',
      type: 'string',
      title: modelFieldMessages.opBlockNumber
    },
    lengths: {
      key: 'lengths',
      type: 'string',
      title: modelFieldMessages.lamellaLength
    },
    status: {
      key: 'status',
      type: 'string',
      title: modelFieldMessages.status
    },
    extraStatus: {
      key: 'extraStatus',
      type: 'string',
      title: modelFieldMessages.extraStatus
    },
    camberedRadius: {
      key: 'camberedRadius',
      type: 'string',
      title: modelFieldMessages.camberedRadius,
      blank: true,
      input: 'number',
      default: 0
    },
    camber: {
      key: 'calcCamber',
      type: 'string',
      title: modelFieldMessages.camber
    },
    hasCamber: {
      key: 'hasCamber',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.hasCamber
    },
    dataSentToPress: {
      key: 'dataSentToPress',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.dataSentToPress
    },
    // numberOfLayers: {
    //   key: 'numberOfLayers',
    //   type: 'string',
    //   blank: true,
    //   title: modelFieldMessages.numberOfLayers
    // },
    stickLayerSeq: {
      key: 'stickLayerSeq',
      type: 'string',
      blank: true,
      title: modelFieldMessages.stickLayerSeq
    },
    numberOfLayersBundle: {
      key: 'numberOfLayersBundle',
      type: 'string',
      blank: true,
      title: modelFieldMessages.numberOfLayersBundle
    },
    stackingName: {
      key: 'stackingName',
      type: 'string',
      title: modelFieldMessages.stackingName
    },
    orderCharge: {
      key: 'orderCharge',
      type: 'string',
      title: modelFieldMessages.orderCharge
    },
    projectName_schilliger: {
      key: 'projectName',
      type: 'string',
      title: modelFieldMessages.projectName_schilliger
    },
    layerId: {
      key: 'layerId',
      type: 'string',
      title: modelFieldMessages.layerId
    },
    identifier: {
      key: 'identifier',
      type: 'string',
      title: modelFieldMessages.identifier
    },
    productionId: {
      key: 'productionId',
      type: 'string',
      title: modelFieldMessages.identifier
    },
    number: {
      key: 'number',
      type: 'string',
      title: modelFieldMessages.orderId
    },
    paNr: {
      key: 'paNr',
      type: 'string',
      title: modelFieldMessages.paNr
    },
    noLayers: {
      key: 'layers',
      type: 'arraylength',
      title: modelFieldMessages.layers
    },
    oversizeWidth: {
      key: 'oversizeWidth',
      type: 'string',
      title: modelFieldMessages.oversizeWidth,
      blank: false,
      validation: ['float']
    },
    oversize: {
      key: 'oversize',
      type: 'string',
      title: modelFieldMessages.oversize,
      blank: false,
      validation: ['float']
    },
    id: {
      key: 'id',
      type: 'string',
      title: modelFieldMessages.id,
      input: 'number',
      step: '1'
    },
    pressId: {
      key: 'pressId',
      type: 'string',
      title: modelFieldMessages.pressId
    },
    woodType: {
      key: 'woodType',
      type: 'string',
      title: modelFieldMessages.woodType,
      format: {
        type: 'wood_type',

        backgroundColorCondition: (item) => {
          const woodType = item?.woodType;

          if (woodType === 'SYP') return '#4D6A5E';
          if (woodType === 'CCA') return '#8E715D';
          if (woodType === 'POC') return '#A79A7B';
          if (woodType === 'AYC') return '#816881';
          if (woodType === 'FIR') return '#53516C';
          if (woodType === 'WIRE CHASE') return '#816881';

          return '';
        }
      }
    },
    splitLamella: {
      key: 'splitLamella',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.splitLamella
    },
    cut1: {
      key: 'cut1',
      type: 'string',
      title: modelFieldMessages.cut1
    },
    cut2: {
      key: 'cut2',
      type: 'string',
      title: modelFieldMessages.cut2
    },
    mode: {
      key: 'mode',
      type: 'choices',
      title: modelFieldMessages.mode,
      format: {
        type: 'discreteChoices',
        choices: _.get(mainUtilsConfig, 'modeChoices', {})
      },
      validation: ['select'],
      blank: false,
      default: Object.keys(_.get(mainUtilsConfig, 'modeChoices[0]', '1'))
    },
    piecesSaws: {
      key: 'piecesSaws',
      type: 'choices',
      title: modelFieldMessages.piecesSaws,
      format: {
        type: 'discreteChoices',
        choices: _.get(mainUtilsConfig, 'piecesSawNumberChoices', {})
      },
      validation: ['select'],
      blank: false,
      default: Object.keys(_.get(mainUtilsConfig, 'piecesSawNumberChoices[0]', '1'))
    },
    mixedLength: {
      key: 'mixedLength',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.mixedLength
    },
    sawAtStacking: {
      key: 'sawAtStacking',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.sawAtStacking
    },
    differentWidths: {
      key: 'differentWidths',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.differentWidths
    },
    isConstruction: {
      key: 'isConstruction',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.isConstruction
    },
    profile: {
      key: 'profile',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.profile
    },
    fem: {
      key: 'profile',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.fem
    },
    softHandling: {
      key: 'softHandling',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.softHandling
    },
    turning0: {
      key: 'turning0',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.turning0
    },
    headPrinting: {
      key: 'headPrinting',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.headPrinting
    },
    bundle: {
      key: 'bundle',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.bundle
    },
    stagger: {
      key: 'stagger',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.stagger
    },
    assignedPressSelect: {
      key: 'assignedPressSelect',
      type: 'select',
      format: {
        item: 'pressList',
        identifier: 'assignedPress',
        wsAction: 'select-assigned-press',
        validationFunction: function (item, selectionParam) {
          if (item?.status !== 'unconfirmed') return true;

          if (item?.assignedPress === 'roto') {
            // roto->flexi
            if (item?.lamellaLength > 18525 || item?.lamellaLength < 8534.4) {
              return true;
            }
            // depth -> lamellaWidth
            if (item?.lamellaWidth > 1955.8 || item?.lamellaWidth < 200) {
              return true;
            }
            if (item?.lamellaThickness > 650 || item?.lamellaThickness < 101.6) {
              return true;
            }
            return false; // ne blokira
          }
          if (item?.assignedPress === 'flexi') {
            // flexi->roto
            if (item?.lamellaLength > 18500 || item?.lamellaLength < 8534.4) {
              return true;
            }
            if (item?.lamellaWidth > 1422.4 || item?.lamellaWidth < 198.12) {
              return true;
            }
            if (item?.lamellaThickness > 320 || item?.lamellaThickness < 0) {
              return true;
            }
            return false;
          }

          return true; // zaenkrat ne izberi nichesar
        }
      },
      title: modelFieldMessages.assignedPress
    },
    addThickness: {
      key: 'addThickness',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.addThickness
    },
    // quality: {
    //     key: 'quality',
    //     type: 'string',
    //     title: modelFieldMessages.orderQuality,
    //     blank: false,
    //     input: 'text',
    // },
    quality: {
      key: 'quality',
      type: 'string',
      title: modelFieldMessages.quality
    },
    name: {
      key: 'name',
      type: 'string',
      title: modelFieldMessages.name,
      input: 'text'
    },
    orderNumber: {
      key: 'orderNumber',
      type: 'string',
      title: modelFieldMessages.orderNumber,
      blank: false,
      input: 'text'
    },
    gpaoId: {
      key: 'gpaoId',
      type: 'string',
      title: modelFieldMessages.gpaoId,
      blank: false,
      input: 'text'
    },
    camberRadiusMm: {
      title: modelFieldMessages.camberRadiusMm,
      key: 'camberRadiusMm',
      type: 'string',
      blank: true,
      input: 'number',
      default: 0,
      fromUnit: 'millimeters',
      toUnit: 'feet',
      unitType: 'length',
      convert: true,
      format: {
        type: 'conversion_from_many',
        str: '{camberRadiusMm} ',
        keys: [{ key: 'camberRadiusMm', fromUnit: 'millimeters', toUnit: 'feet' }],
        fromUnitLabel: 'mm',
        toUnitLabel: 'ft',
        unitType: 'length'
      }
    },
    chargeNumber: {
      key: 'chargeNumber',
      type: 'string',
      title: modelFieldMessages.chargeNumber,
      blank: false,
      input: 'text'
    },
    jobNumber: {
      key: 'jobNumber',
      type: 'string',
      title: modelFieldMessages.jobNumber,
      blank: false,
      input: 'text'
    },
    smartlamOrderNumber: {
      key: 'orderNumber',
      type: 'string',
      title: modelFieldMessages.smartlamOrderNumber,
      blank: false,
      input: 'text'
    },
    orderImportNumber: {
      key: 'orderImportNumber',
      type: 'string',
      title: modelFieldMessages.orderImportNumber,
      blank: false,
      input: 'text'
    },
    erp_order_id: {
      key: 'erp_order_id',
      type: 'string',
      title: modelFieldMessages.erp_order_id,
      input: 'text'
    },
    assignedPress: {
      key: 'assignedPress',
      type: 'choices',
      title: modelFieldMessages.assignedPress,
      format: {
        type: 'discreteChoices',
        choices: _.get(mainUtilsConfig, 'assignedPressChoices', {})
      },
      validation: ['select'],
      blank: false,
      default: Object.keys(_.get(mainUtilsConfig, 'assignedPressChoices', '0'))[0]
    },
    assignedPressString: {
      key: 'assignedPress',
      type: 'string',
      title: modelFieldMessages.assignedPress
    },
    assignedStorage: {
      key: 'assignedStorage',
      type: 'choices',
      title: modelFieldMessages.storage,
      format: {
        type: 'discreteChoices',
        choices: _.get(mainUtilsConfig, 'storageChoices', {})
      },
      validation: ['select'],
      blank: false,
      default: Object.keys(_.get(mainUtilsConfig, 'storageChoices', '0'))[0]
    },
    assignedStorageString: {
      key: 'assignedStorage',
      type: 'string',
      title: modelFieldMessages.storage
    },
    manualEntry: {
      key: 'manualEntry',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.manualEntry
    },
    useLKS: {
      key: 'useLKS',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.useLKS
    },
    glueDefinedSequence: {
      key: 'glueDefinedSequence',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.glueDefinedSequence
    },
    ignorePlanerData: {
      key: 'ignorePlanerData',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.ignorePlanerData
    },
    forceGroupSequencing: {
      key: 'forceGroupSequencing',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.forceGroupSequencing
    },
    beamGlueEnd: {
      key: 'beamGlueEnd',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.beamGlueEnd
    },
    // client: {
    //   key: 'client',
    //   type: 'string',
    //   title: modelFieldMessages.clientTitle,
    //   blank: false,
    //   filterable: true
    // },
    outsideBeamPlaning: {
      key: 'outsideBeamPlaning',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.outsideBeamPlaning
    },
    client: {
      key: 'client',
      type: 'string',
      title: modelFieldMessages.clientTitle,
      blank: false,
      filterable: true
    },
    iBeamNumber: {
      key: 'iBeamNumber',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.liftNo,
      default: '1'
    },
    iPressNumber: {
      key: 'iPressNumber',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.iPressNumber,
      default: '1'
    },
    pieces: {
      key: 'pieces',
      type: 'string',
      title: modelFieldMessages.piecesTitle,
      width: 2
    },
    incomingLamellaWidth: {
      key: 'incomingLamellaWidth',
      title: modelFieldMessages.incomingLamellaWidth,
      type: 'string'
    },
    incomingLamellaThickness: {
      key: 'incomingLamellaThickness',
      title: modelFieldMessages.incomingLamellaThickness,
      type: 'string'
    },
    lamellaWidth: {
      title: modelFieldMessages.lamellaWidthActual,
      key: 'lamellaWidth',
      type: 'string',
      blank: false,
      validation: ['float', 'aboveZero'],
      conversionType: 'length',
      modelValidation: [
        {
          valueLimit: 'above',
          fromGlobal: true,
          globalKey: 'maxLamellaWidth',
          errorMessage: 'lamellaTooWide'
        },
        {
          valueLimit: 'below',
          fromGlobal: true,
          globalKey: 'minLamellaWidth',
          errorMessage: 'lamellaTooNarrow'
        }
      ],
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    lamellaWidthNoValidation: {
      title: modelFieldMessages.lamellaWidthActual,
      key: 'lamellaWidth',
      type: 'string',
      input: 'number',
      conversionType: 'length',
      blank: true,
      modelValidation: [
        {
          valueLimit: 'above',
          fromGlobal: true,
          globalKey: 'maxLamellaWidth',
          errorMessage: 'lamellaTooWide'
        },
        {
          valueLimit: 'below',
          fromGlobal: true,
          globalKey: 'minLamellaWidth',
          errorMessage: 'lamellaTooNarrow'
        }
      ],
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    lamellaThickness: {
      title: modelFieldMessages.lamellaThickness,
      key: 'lamellaThickness',
      type: 'string',
      input: 'number',
      blank: true,
      validation: ['float', 'aboveZero'],
      modelValidation: [
        {
          valueLimit: 'above',
          fromGlobal: true,
          globalKey: 'maxLamellaThickness',
          errorMessage: 'lamellaTooThick'
        },
        {
          valueLimit: 'below',
          fromGlobal: true,
          globalKey: 'minLamellaThickness',
          errorMessage: 'lamellaTooLow'
        }
      ],
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    lamellaThicknessNoValidation: {
      title: modelFieldMessages.lamellaThickness,
      key: 'lamellaThickness',
      type: 'string',
      conversionType: 'length',
      input: 'number',
      blank: true,
      modelValidation: [
        {
          valueLimit: 'above',
          fromGlobal: true,
          globalKey: 'maxLamellaThickness',
          errorMessage: 'lamellaTooThick'
        },
        {
          valueLimit: 'below',
          fromGlobal: true,
          globalKey: 'minLamellaThickness',
          errorMessage: 'lamellaTooLow'
        }
      ],
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    lamellaLength: {
      title: modelFieldMessages.lamellaLength,
      key: 'lamellaLength',
      type: 'string',
      blank: false,
      validation: ['float', 'aboveZero'],
      modelValidation: [
        {
          valueLimit: 'above',
          fromGlobal: true,
          globalKey: 'maxLamellaLength',
          errorMessage: 'lamellaTooLong'
        },
        {
          valueLimit: 'below',
          fromGlobal: true,
          globalKey: 'minLamellaLength',
          errorMessage: 'lamellaTooShort'
        }
      ]
    },

    lamellaPlannedWidth: {
      title: modelFieldMessages.lamellaPlannedWidth,
      key: 'rawWidth',
      type: 'string',
      blank: false,
      validation: ['float', 'aboveZero']
    },
    lamellaPlannedThickness: {
      title: modelFieldMessages.lamellaPlannedThickness,
      key: 'rawThickness',
      type: 'string',
      blank: false,
      validation: ['float', 'aboveZero'],
      input: 'number',
      step: '.1'
    },
    rawWidth: {
      title: modelFieldMessages.rawWidth,
      key: 'rawWidth',
      type: 'string',
      input: 'number',
      blank: false,
      conversionType: 'length',
      validation: ['float', 'aboveZero'],
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    rawThickness: {
      title: modelFieldMessages.rawThickness,
      key: 'rawThickness',
      conversionType: 'length',
      type: 'string',
      blank: false,
      validation: ['float', 'aboveZero'],
      input: 'number',
      step: '.1',
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    rawLamellaThickness: {
      title: modelFieldMessages.rawThickness,
      key: 'rawLamellaThickness',
      type: 'string',
      blank: false,
      conversionType: 'length',
      validation: ['float', 'aboveZero'],
      input: 'number',
      step: '.1',
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    rawLamellaWidth: {
      title: modelFieldMessages.rawWidth,
      key: 'rawLamellaWidth',
      type: 'string',
      blank: false,
      conversionType: 'length',
      validation: ['float', 'aboveZero'],
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length'
    },
    addedAt: {
      key: 'addedAt',
      title: modelFieldMessages.addedAt,
      format: {
        type: 'date'
      }
    },
    scannedAt: {
      key: 'scannedAt',
      title: modelFieldMessages.addedAt,
      format: {
        type: 'date'
      }
    },
    erpDate: {
      key: 'erpDate',
      title: modelFieldMessages.erpDate,
      format: {
        type: 'date'
      }
    },
    completedAt: {
      key: 'completedAt',
      title: modelFieldMessages.completedAt,
      format: {
        type: 'date'
      }
    },
    productionDate: {
      key: 'productionDate',
      title: modelFieldMessages.productionDate,
      format: {
        type: 'date'
      }
    },
    lineNumber: {
      key: 'line',
      title: modelFieldMessages.lineNumber
    },
    priority: {
      key: 'priority',
      type: 'string',
      title: modelFieldMessages.priority
    },
    validated: {
      key: 'validated',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.validated
    },
    dimensions: {
      key: 'dimensions',
      title: modelFieldMessages.dimensions,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} mm',
        keys: ['lamellaWidth', 'lamellaThickness', 'lamellaLength']
      }
    },
    dimensionsConverted: {
      key: 'dimensions',
      title: modelFieldMessages.dimensions,
      format: {
        type: 'conversion_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} ',
        keys: [
          { key: 'lamellaThickness', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaWidth', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaLength', fromUnit: 'millimeters', toUnit: 'inches' }
        ],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length'
      }
    },
    dimensionsConvertedLengthInFeet: {
      key: 'dimensions',
      title: modelFieldMessages.dimensions,
      format: {
        type: 'conversion_from_many',
        str: '{lamellaThickness} x {lamellaWidth}',
        keys: [
          { key: 'lamellaThickness', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'lamellaWidth', fromUnit: 'millimeters', toUnit: 'inches' }
        ],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length'
      }
    },
    rawDimensions: {
      key: 'rawDimensions',
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'object_from_many',
        str: '{rawThickness} x {rawWidth} x {lamellaLength} mm',
        keys: ['rawWidth', 'rawThickness', 'lamellaLength']
      }
    },
    rawDimensionsConvertedAndColorized: {
      key: 'rawDimensions',
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'conversion_from_many',
        str: '{rawThickness} x {rawWidth}',
        keys: [
          { key: 'rawThickness', fromUnit: 'millimeters', toUnit: 'inches' },
          { key: 'rawWidth', fromUnit: 'millimeters', toUnit: 'inches' }
        ],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length',
        backgroundColorCondition: (item) => {
          const widthInches = Number(item?.rawWidth) / 25.4;
          const nominalWidth = Math.round(widthInches);

          if (nominalWidth === 4) return '#dbeafe';
          if (nominalWidth === 6) return '#e0e7ff';
          if (nominalWidth === 8) return '#e8bbfd';
          if (nominalWidth === 10) return '#fef3c7';
          if (nominalWidth === 12) return '#ffedd5';

          return '';
        }
      }
    },
    rawBeamDimensions: {
      key: 'rawDimensions',
      title: modelFieldMessages.rawBeamDimensions,
      format: {
        type: 'object_from_many',
        str: '{lamellaWidth} x {beamWidthRaw} x {lamellaLength} mm',
        keys: ['lamellaWidth', 'beamWidthRaw', 'lamellaLength']
      }
    },
    finalBeamDimensions: {
      key: 'rawDimensions',
      title: modelFieldMessages.finalBeamDimensions,
      format: {
        type: 'object_from_many',
        str: '{beamThicknessFinal} x {beamWidthFinal} mm',
        keys: ['beamWidthFinal', 'beamThicknessFinal']
      }
    },
    noLengthDimensions: {
      key: 'noLengthDimensions',
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'object_from_many',
        str: '{rawThickness} x {rawWidth} mm',
        keys: ['rawWidth', 'rawThickness']
      }
    },
    noLengthDimensionsSortedOrder: {
      key: 'noLengthDimensions',
      title: modelFieldMessages.rawDimensions,
      format: {
        type: 'object_from_many',
        str: '{rawLamellaThickness} x {rawLamellaWidth} mm',
        keys: ['rawLamellaThickness', 'rawLamellaWidth']
      }
    },
    noLengthFinalDimensions: {
      key: 'noLengthDimensions',
      title: modelFieldMessages.finalDimension,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} mm',
        keys: ['lamellaThickness', 'lamellaWidth']
      }
    },
    kvhDimensions: {
      key: 'dimensions',
      title: modelFieldMessages.kvhDimensions,
      format: {
        type: 'eval_function',
        str: "{isKVH} == true ? ({lamellaThickness} + ' x ' + {lamellaWidth} + ' x ' + {lamellaLength}) : ({panelThickness} + 'x' + {panelWidth} + 'x' + {panelLength})",
        keys: {
          isKVH: '{isKVH}',
          lamellaWidth: '{lamellaWidth}',
          lamellaLength: '{lamellaLength}',
          lamellaThickness: '{lamellaThickness}',
          panelThickness: '{panelThickness}',
          panelWidth: '{panelWidth}',
          panelLength: '{panelLength}'
        },
        evalFinalString: true
      }
    },
    orderDimensions: {
      key: 'dimensions',
      title: modelFieldMessages.lamellaDimensions,
      width: 1.5,
      format: {
        type: 'object_from_many',
        str: '{panelThickness} x {orderWidth} x {panelLength} mm',
        keys: ['panelThickness', 'orderWidth', 'panelLength']
      }
    },
    packageDimensions: {
      key: 'package_dimensions',
      title: modelFieldMessages.lamellaDimensions,
      width: 1.5,
      format: {
        type: 'object_from_many',
        str: '{lamellaThickness} x {lamellaWidth} x {lamellaLength} mm',
        keys: ['lamellaWidth', 'lamellaThickness', 'lamellaLength']
      }
    },
    incomingPackageDimensions: {
      key: 'package_dimensions',
      title: modelFieldMessages.incomingLamellaDimensions,
      width: 1.5,
      format: {
        type: 'object_from_many',
        str: '{incomingLamellaThickness} x {incomingLamellaWidth} mm',
        keys: ['incomingLamellaThickness', 'incomingLamellaWidth']
      }
    },
    type: {
      key: 'type',
      type: 'choices',
      title: modelFieldMessages.orderType,
      format: {
        type: 'discreteChoices',
        choices: BSHOrder.packageTypeChoices
      }
    },
    isKVH: {
      key: 'isKVH',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.isKVH
    },
    wrapping: {
      key: 'wrapping',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.wrapping
    },
    orderColor: {
      key: 'orderColor',
      type: 'string',
      format: {
        type: 'color'
      }
    },
    headCut: {
      key: 'headCut',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.headCut
    },
    middleCut: {
      key: 'middleCut',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.middleCut
    },
    endCut: {
      key: 'endCut',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.endCut
    },
    withMosca: {
      key: 'withMosca',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.withMosca
    },
    stopper: {
      key: 'stopper',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.stopper
    },
    jobCode: {
      key: 'jobCode',
      type: 'string',
      title: modelFieldMessages.jobCode,
      blank: false
    },
    rowsNumber: {
      key: 'rowsNumber',
      type: 'string',
      title: modelFieldMessages.rowsNumber,
      blank: false
    },
    colsNumber: {
      key: 'colsNumber',
      type: 'string',
      title: modelFieldMessages.colsNumber,
      blank: false
    },
    kvhBoards: {
      key: 'kvhBoards',
      type: 'string',
      title: modelFieldMessages.kvhBoards,
      blank: false
    },
    orderPicture: {
      key: 'picture',
      type: 'drawPicture',
      title: modelFieldMessages.picture,
      function: 'getCLTOrderImage'
    },
    stackingNumOfLayers: {
      key: 'stackingNumOfLayers',
      type: 'string',
      title: modelFieldMessages.stackingNumOfLayers,
      blank: false
    },
    finalBeamThickness: {
      type: 'string',
      key: 'finalBeamThickness',
      convert: true,
      fromUnit: 'millimeters',
      toUnit: 'inches',
      unitType: 'length',
      title: modelFieldMessages.finalBeamThickness,
      format: {
        type: 'conversion_from_many',
        str: '{finalBeamThickness} ',
        keys: [{ key: 'finalBeamThickness', fromUnit: 'millimeters', toUnit: 'inches' }],
        fromUnitLabel: 'mm',
        toUnitLabel: 'in',
        unitType: 'length'
      }
    },
    stackingLamellasPerLayer: {
      key: 'stackingLamellasPerLayer',
      type: 'string',
      title: modelFieldMessages.stackingLamellasPerLayer,
      blank: false
    },
    orderType: {
      key: 'orderType',
      title: modelFieldMessages.orderType,
      type: 'choices',
      format: {
        type: 'discreteChoices',
        retainNames: true,
        choices: BSHOrder.productChoices
      },
      blank: false
    },
    orderTypeString: {
      key: 'orderTypeString',
      type: 'string',
      title: modelFieldMessages.orderType,
      blank: false
    },
    lineRegimeNum: {
      key: 'lineRegimeNum',
      title: modelFieldMessages.lineRegime,
      type: 'choices',
      format: {
        type: 'discreteChoices',
        retainNames: true,
        choices: BSHOrder.lineRegimeChoices
      },
      blank: false
    },
    numOfLamellas: {
      key: 'numOfLamellas',
      title: modelFieldMessages.numOfLamellas,
      type: 'string',
      blank: false
    },
    numberOfWidths: {
      key: 'numberOfWidths',
      title: modelFieldMessages.numberOfWidths,
      type: 'string',
      blank: false
    },
    numberOfLayers: {
      key: 'numberOfLayers',
      title: modelFieldMessages.numberOfLayers,
      type: 'string',
      blank: true
    },
    moscaNumberOfBoards: {
      key: 'moscaNumberOfBoards',
      title: modelFieldMessages.moscaNumberOfBoards,
      type: 'string',
      blank: true
    },
    lengthMiddleCut1: {
      key: 'lengthMiddleCut1',
      title: modelFieldMessages.lengthMiddleCut1,
      type: 'string',
      blank: true
    },
    lengthMiddleCut2: {
      key: 'lengthMiddleCut2',
      title: modelFieldMessages.lengthMiddleCut2,
      type: 'string',
      blank: true
    },
    numOfPackages: {
      key: 'numOfPackages',
      title: modelFieldMessages.numOfPackages,
      type: 'string',
      blank: false
    },
    zincDoneNumLamellas: {
      key: 'zincDoneNumLamellas',
      type: 'string',
      title: modelFieldMessages.zincDoneNumLamellas
    },
    direction: {
      key: 'direction',
      type: 'choices',
      title: modelFieldMessages.direction,
      format: {
        type: 'discreteChoices',
        choices: mainUtilsConfig.exitChoices
      }
    },
    directionFournier: {
      key: 'direction',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.destinationFournier
    },
    // eslint-disable-next-line no-dupe-keys
    iBeamNumber: {
      key: 'iBeamNumber',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.iBeamNumber
    },
    glueType: {
      key: 'glueType',
      type: 'string',
      title: modelFieldMessages.glueType
    },
    iDestPress: {
      key: 'iDestPress',
      type: 'string',
      title: modelFieldMessages.iDestPress
    },
    iDestStorage: {
      key: 'iDestStorage',
      type: 'string',
      title: modelFieldMessages.zincDoneNumLamellas
    },
    notes1: {
      key: 'notes1',
      type: 'string',
      title: modelFieldMessages.notes1
    },
    iLayerInPress: {
      key: 'iLayerInPress',
      type: 'string',
      title: modelFieldMessages.iLayerInPress
    },
    iCostReceiver: {
      key: 'iCostReceiver',
      type: 'string',
      title: modelFieldMessages.iCostReceiver
    },
    iProdSequence: {
      key: 'iProdSequence',
      type: 'string',
      title: modelFieldMessages.iProdSequence
    },
    iStackHeight: {
      key: 'iStackHeight',
      type: 'string',
      title: modelFieldMessages.iStackHeight
    },
    iChinkSaw: {
      key: 'iChinkSaw',
      type: 'string',
      title: modelFieldMessages.iChinkSaw
    },
    finishedLamellaThickness: {
      key: 'finishedLamellaThickness',
      type: 'string',
      title: modelFieldMessages.finishedLamellaThickness
    },
    finishedLamellaWidth: {
      key: 'finishedLamellaWidth',
      type: 'string',
      title: modelFieldMessages.finishedLamellaWidth
    },
    strComment: {
      key: 'strComment',
      type: 'string',
      title: modelFieldMessages.strComment
    },
    productionInfo: {
      key: 'strComment',
      type: 'string',
      title: modelFieldMessages.productionInfo
    },
    glueAmount: {
      key: 'glueAmount',
      type: 'string',
      title: modelFieldMessages.glueAmount
    },
    pressTime: {
      key: 'pressTime',
      type: 'string',
      title: modelFieldMessages.pressTime
    },
    iBeamId: {
      key: 'iBeamId',
      type: 'string',
      title: modelFieldMessages.iBeamId
    },
    iFinishedWidth: {
      key: 'iFinishedWidth',
      type: 'string',
      title: modelFieldMessages.iFinishedWidth
    },
    piecesPerLayer: {
      key: 'piecesPerLayer',
      type: 'string',
      title: modelFieldMessages.piecesPerLayer
    },
    piecesPerLayerBundle: {
      key: 'piecesPerLayerBundle',
      type: 'string',
      title: modelFieldMessages.piecesPerLayerBundle
    },
    iFinishedHeight: {
      key: 'iFinishedHeight',
      type: 'string',
      title: modelFieldMessages.iFinishedHeight
    },
    iFinishedLength: {
      key: 'iFinishedLength',
      type: 'string',
      title: modelFieldMessages.iFinishedLength
    },
    iBendingRadius: {
      key: 'iBendingRadius',
      type: 'string',
      title: modelFieldMessages.iBendingRadius
    },
    bshDimensions: {
      key: 'dimensions',
      title: modelFieldMessages.kvhDimensions,
      format: {
        type: 'eval_function',
        str: "{finishedLamellaThickness} + ' x ' + {finishedLamellaWidth}",
        keys: {
          finishedLamellaWidth: '{finishedLamellaWidth}',
          finishedLamellaThickness: '{finishedLamellaThickness}'
        },
        evalFinalString: true
      }
    },
    beamPicture: {
      key: 'picture',
      type: 'drawPicture',
      title: modelFieldMessages.picture,
      function: 'getBSHBeamImage',
      halfsize: false
    },
    pressingMatrix: {
      type: 'string',
      identifier: 'pressingMatrix',
      color: 'blue',
      format: {
        type: 'productStack'
      }
    },
    pressedMatrix: {
      type: 'string',
      identifier: 'pressedMatrix',
      color: 'green',
      format: {
        type: 'productStack'
      }
    },
    shoePositions: {
      key: 'shoePositions',
      type: 'ListViewAdd',
      input: 'number',
      format: [ShoePosition.fields.angle, ShoePosition.fields.position],
      title: function (item) {
        // return _.get(item, 'billetSequence', '');
        return 'Shoe Positions';
      },
      editable: true,
      defaultValue: []
    },
    startCU: {
      key: 'startCU',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.startCU,
      default: '1'
    },
    quantity: {
      key: 'quantity',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.quantity,
      default: '0'
    },
    bendingPosition: {
      key: 'bendingPosition',
      type: 'string',
      input: 'number',
      title: modelFieldMessages.bendingPosition,
      default: '0'
    },
    description: {
      key: 'description',
      type: 'string',
      title: modelFieldMessages.description,
      input: 'text'
    },
    numeroAffaire: {
      key: 'numeroAffaire',
      type: 'string',
      title: modelFieldMessages.numeroAffaire
    },
    // eslint-disable-next-line no-dupe-keys
    client: {
      key: 'client',
      type: 'string',
      title: modelFieldMessages.client
    },
    nomProjet: {
      key: 'nomProjet',
      type: 'string',
      title: modelFieldMessages.nomProjet
    },
    transportCollage: {
      key: 'transportCollage',
      type: 'string',
      title: modelFieldMessages.transportCollage
    },
    largeur: {
      key: 'largeur',
      type: 'string',
      title: modelFieldMessages.largeur
    },
    hauteur: {
      key: 'hauteur',
      type: 'string',
      title: modelFieldMessages.hauteur
    },
    longueur: {
      key: 'longueur',
      type: 'string',
      title: modelFieldMessages.longueur
    },
    typesDeTaillages: {
      key: 'typesDeTaillages',
      type: 'string',
      title: modelFieldMessages.typesDeTaillages
    },
    colis: {
      key: 'colis',
      type: 'string',
      title: modelFieldMessages.colis
    },
    position: {
      key: 'position',
      type: 'string',
      title: modelFieldMessages.position
    },
    remarques: {
      key: 'remarques',
      type: 'string',
      title: modelFieldMessages.remarques
    },
    conveyorPos: {
      key: 'conveyorPos',
      type: 'string',
      title: modelFieldMessages.conveyorPos
    },
    qcSample: {
      key: 'qcSample',
      type: 'boolean',
      format: {
        type: 'boolean'
      },
      title: modelFieldMessages.qcSample
    },
    setNumber: {
      key: 'setNumber',
      type: 'string',
      title: modelFieldMessages.setNumber
    }
  };

  static actions = {
    moveRowToDone: {
      key: 'moveToDone',
      type: 'moveToDone',
      title: modelFieldMessages.moveToDone,
      modal: {
        modal: true,
        buttonText: 'moveToDone',
        key: 'moveToDone',
        action: 'moveToDone',
        icon: 'moveIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'order-to-move-to-done',
          items: 'selected',
          callType: 'POST',
          refreshSource: 'orders/bsh/?status=producing'
        }
      }
    },
    deleteOrder: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteOrder',
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'deleteOrder',
        key: 'deleteOrder',
        action: 'deleteOrder',
        icon: 'deleteIcon',
        actionData: {
          target: 'backend',
          source: 'orders/bsh/?status=todo',
          url: '/api/v1/orders/bsh/remove_bsh/',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.deleteOrder
    },
    purgeOrder: {
      key: 'delete',
      type: 'delete',
      dispatch: 'purgeOrder',
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'purgeOrder',
        key: 'purgeOrder',
        action: 'purgeOrder',
        icon: 'deleteIcon',
        actionData: {
          target: 'backend',
          source: 'orders/bsh/?status=deleted',
          url: '/api/v1/orders/bsh/purge_bsh/',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.purgeOrder
    },
    deleteControlOrderScanned: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteOrder',
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'deleteOrder',
        key: 'deleteOrder',
        action: 'deleteOrder',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'order-to-remove-from-scanned-queue',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.deleteOrder
    },
    deleteControlOrder: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteOrder',
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'deleteOrder',
        key: 'deleteOrder',
        action: 'deleteOrder',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'order-to-remove-from-queue',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.deleteOrder
    },
    deleteExitDataEntry: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteExitDataEntry',
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'deleteExitDataEntry',
        key: 'deleteExitDataEntry',
        action: 'deleteExitDataEntry',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          identifier: 'entry-to-remove-from-exit-data',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    deleteTestCutHistoryEntry: {
      key: 'delete',
      type: 'delete',
      dispatch: 'deleteTestCutHistoryEntry',
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'deleteTestCutHistoryEntry',
        key: 'deleteTestCutHistoryEntry',
        action: 'deleteTestCutHistoryEntry',
        icon: 'deleteIcon',
        actionData: {
          target: 'control',
          identifier: 'delete-test-cut-history-entry',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    setToPress: {
      key: 'setToPress',
      type: 'controlAction',
      adminRequired: false,
      format: {
        compareField: false,
        icon: 'SendData',
        style: { fontSize: '27px', color: 'black' }
      },
      modal: {
        modal: true,
        buttonText: 'setToPress',
        key: 'setToPress',
        action: 'setToPress',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'set-to-press',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.setToPress
    },
    moveUp: {
      key: 'moveUp',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'moveUp',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'moveUp',
        key: 'moveUp',
        action: 'moveUp',
        icon: 'moveUp',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'move-order-by-group',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveUp,
      additionalParameters: { direction: 'up' }
    },
    moveDown: {
      key: 'moveDown',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'moveDown',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'moveDown',
        key: 'moveDown',
        action: 'moveDown',
        icon: 'moveDown',
        adminRequired: true,
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'move-order-by-group',
          items: 'selected',
          additionalParameters: { direction: 'down' },
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveDown,
      additionalParameters: { direction: 'down' }
    },
    moveUpOrderQueue: {
      key: 'moveUp',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'moveUp',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'moveUp',
        key: 'moveUp',
        action: 'moveUp',
        icon: 'moveUp',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'move-order-up-queue',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveUp
    },
    moveDownOrderQueue: {
      key: 'moveDown',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'moveDown',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'moveDown',
        key: 'moveDown',
        action: 'moveDown',
        icon: 'moveDown',
        adminRequired: false,
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'move-order-down-queue',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveDown
    },
    moveOrderToActive: {
      key: 'moveToActive',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'Restore',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: true,
      modal: {
        modal: true,
        buttonText: 'moveToActive',
        key: 'moveToActive',
        action: 'moveToActive',
        icon: 'Restore',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'order-to-move-to-active',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveOrderToActive
    },
    oAuthApiTest: {
      key: 'oAuthApiTest',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'oAuthApiTestIcon',
        style: { fontSize: '27px', color: 'black' }
      },
      modal: {
        modal: true,
        buttonText: 'oAuthApiTest',
        key: 'oAuthApiTest',
        action: 'oAuthApiTest',
        icon: 'oAuthApiTestIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'oAuth-api-test',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.oAuthApiTest
    },
    fjApiTest: {
      key: 'fjApiTest',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'oAuthApiTestIcon',
        style: { fontSize: '27px', color: 'black' }
      },
      modal: {
        modal: true,
        buttonText: 'fjApiTest',
        key: 'fjApiTest',
        action: 'fjApiTest',
        icon: 'oAuthApiTestIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'oAuth-api-testFJ',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.fjApiTest
    },
    recalculateOrder: {
      key: 'recalculateOrder',
      type: 'controlAction',
      format: {
        compareField: false,
        icon: 'Calculator',
        style: { fontSize: '27px', color: 'black' }
      },
      modal: {
        modal: true,
        buttonText: 'recalculateOrder',
        key: 'recalculateOrder',
        action: 'recalculateOrder',
        icon: 'oAuthApiTestIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'recalculate-order',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.recalculateOrder
    },
    editOrder: {
      key: 'edit',
      type: 'edit',
      identifier: 'editOrder',
      configuration: {
        model: 'bshorder',
        url: '/api/v1/orders/bsh/'
      }
    },
    uploadFileToModel: {
      key: 'uploadFileToModel',
      type: 'uploadFileToModel',
      identifier: 'uploadFileToModel',
      title: 'upload',
      configuration: {
        model: 'bshorder',
        fileType: '',
        url: '/api/v1/files/upload_file_to_model/'
      }
    },
    uploadShoePositionFile: {
      key: 'uploadShoePositionFile',
      type: 'uploadFileToModel',
      identifier: 'uploadFileToModel',
      title: 'Shoe pos.',
      configuration: {
        model: 'bshorder',
        fileType: 'shoePosition',
        url: '/api/v1/files/upload_file_to_model/'
      }
    },
    uploadCadworkFile: {
      key: 'uploadCadworkFile',
      type: 'uploadFileToModel',
      identifier: 'uploadFileToModel',
      title: 'Cadwork',
      configuration: {
        model: 'bshorder',
        fileType: 'cadworkRigidply',
        url: '/api/v1/files/upload_file_to_model/'
      }
    },
    editControlOrder: {
      adminRequired: false,
      key: 'editControlOrder',
      format: {
        type: 'action',
        modalTo: '/api/v1/orders/all/',
        icon: 'split',
        style: { fontSize: '27px', color: 'black' }
      },
      title: modelFieldMessages.edit
    },
    activateOrder: {
      key: 'activateOrder',
      type: 'controlAction',
      dispatch: 'activateOrder',
      format: {
        icon: 'planeIcon',
        style: { fontSize: '27px', color: 'black' }
      },
      adminRequired: false,
      modal: {
        modal: true,
        buttonText: 'activateOrderTitle',
        key: 'activateOrderTitle',
        action: 'activateOrderTitle',
        icon: 'moveIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'activate-order',
          items: 'selected',
          callType: 'POST'
        }
      }
    },
    editSortedOrder: {
      key: 'edit',
      type: 'edit',
      identifier: 'editSortedOrder',
      configuration: {
        model: 'sortedorder',
        url: '/api/v1/orders/sortedorders/'
      }
    },
    moveOrderToDone: {
      key: 'moveToDone',
      type: 'moveToDone',
      dispatch: 'moveToDone',
      modal: {
        modal: true,
        buttonText: 'moveToDone',
        key: 'moveToDone',
        action: 'moveToDone',
        icon: 'moveIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'order-to-move-to-done',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveOrderToDone
    },
    moveOrderToNextCheckpoint: {
      key: 'moveOrderToNextCheckpoint',
      type: 'moveOrderToNextCheckpoint',
      dispatch: 'moveOrderToNextCheckpoint',
      modal: {
        modal: true,
        buttonText: 'moveOrderToNextCheckpoint',
        key: 'moveOrderToNextCheckpoint',
        action: 'moveOrderToNextCheckpoint',
        icon: 'moveIcon',
        actionData: {
          target: 'control',
          source: 'ordersqueue',
          identifier: 'order-to-move-to-next-checkpoint',
          items: 'selected',
          callType: 'POST'
        }
      },
      title: modelFieldMessages.moveOrderToNextCheckpoint
    },
    showJDForOneOrder: {
      key: 'showJDForOneOrder',
      type: 'showJDForOneOrder',
      format: {
        compareField: false,
        icon: 'ListIcon',
        style: { fontSize: '27px', color: 'black' }
      },
      modal: {
        modal: true,
        buttonText: 'showJDForOneOrder',
        key: 'modal-jd-queue-for-one-order',
        action: 'showJDForOneOrder',
        icon: 'ListIcon',
        actionData: {}
      },
      title: modelFieldMessages.showJDForOneOrder
    },
    printLabelFournier: {
      type: 'action',
      key: 'customModalAction',
      format: {
        type: 'action',
        icon: 'printIcon',
        style: { fontSize: '33px', color: 'black' }
      },
      itemsKey: '',
      viewFunction: (itemState, setLocalState, localState, tmpState, setTmpState) => {
        return (
          <div style={{ width: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Select Printer
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="printer-select-label">Printer</InputLabel>
              <Select labelId="printer-select-label" value={tmpState || ''} label="Printer" onChange={(e) => setTmpState(e.target.value)}>
                <MenuItem value="HyperPressPrinter">HyperPress Printer</MenuItem>
                <MenuItem value="SuperlesPrinter">Superles Printer</MenuItem>
              </Select>
            </FormControl>
          </div>
        );
      },
      onSave: (currentItemState, dispatch, closeFn, tmpState) => {
        dispatch(sendToWs({ ...currentItemState?.item, assignedPress: tmpState }, 'print-sticker-for-order'));
      },
      title: modelFieldMessages.selectPrinter
    },
    printLabelRigidply: {
      type: 'action',
      key: 'customModalAction',
      format: {
        type: 'action',
        icon: 'printIcon',
        style: { fontSize: '33px', color: 'black' }
      },
      itemsKey: '',
      viewFunction: (itemState, setLocalState, localState, tmpState, setTmpState) => {
        return <div style={{ width: '100%' }}>No data to display yet.</div>;
      },
      onSave: (currentItemState, dispatch, closeFn, tmpState) => {
        dispatch(sendToWs({ groupUUID: currentItemState?.item?.groupUUID, id: currentItemState?.item?.id }, 'set-printed-to-false'));
      },
      title: modelFieldMessages.selectPrinter
    },
    printLabelForOrder: {
      type: 'printLabelForOrder',
      key: 'printLabelForOrder',
      format: {
        type: 'action',
        icon: 'printIcon',
        style: { fontSize: '33px', color: 'black' }
      },
      title: modelFieldMessages.selectPrinter
    },
    printStickerOnlyForOrder: {
      type: 'action',
      key: 'customModalAction',
      format: {
        type: 'action',
        icon: 'printIcon',
        style: { fontSize: '33px', color: 'black' }
      },
      itemsKey: '',
      viewFunction: (itemState, setLocalState, localState, tmpState, setTmpState) => {
        return (
          <div style={{ width: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Select Printer
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="printer-select-label">Printer</InputLabel>
              <Select labelId="printer-select-label" value={tmpState || ''} label="Printer" onChange={(e) => setTmpState(e.target.value)}>
                <MenuItem value="FlexiPressPrinter">FlexiPress</MenuItem>
                <MenuItem value="RotoPressPrinter">RotoPress</MenuItem>
                <MenuItem value="CutSawPrinter">CutSaw</MenuItem>
              </Select>
            </FormControl>
          </div>
        );
      },
      onSave: (currentItemState, dispatch, closeFn, tmpState) => {
        dispatch(sendToWs({ ...currentItemState?.item, assignedPress: tmpState }, 'print-sticker-for-order'));
      },
      title: modelFieldMessages.selectPrinter
    },
    printSticker: {
      type: 'action',
      key: 'customModalAction',
      format: {
        type: 'action',
        icon: 'printIcon',
        style: { fontSize: '33px', color: 'black' }
      },
      itemsKey: '',
      viewFunction: (itemState, setLocalState, localState, tmpState, setTmpState) => {
        return (
          <div style={{ width: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Select Printer
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="printer-select-label">Printer</InputLabel>
              <Select labelId="printer-select-label" value={tmpState || ''} label="Printer" onChange={(e) => setTmpState(e.target.value)}>
                <MenuItem value="FlexiPressPrinter">FlexiPress</MenuItem>
                <MenuItem value="RotoPressPrinter">RotoPress</MenuItem>
                <MenuItem value="CutSawPrinter">CutSaw</MenuItem>
              </Select>
            </FormControl>
          </div>
        );
      },
      onSave: (currentItemState, dispatch, closeFn, tmpState) => {
        dispatch(sendToWs({ ...currentItemState?.item, assignedPress: tmpState }, 'print-sticker-for-order'));
      },
      title: modelFieldMessages.selectPrinter
    },
    printStickerFromBackend: {
      type: 'action',
      key: 'printSticker',
      format: {
        type: 'action',
        icon: 'printIcon',
        style: { fontSize: '33px', color: 'black' }
      },
      itemsKey: '',
      configuration: {
        viewFunction: (itemState, setLocalState, localState, tmpState, setTmpState) => {
          return (
            <div style={{ width: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Select Printer
              </Typography>
              <FormControl fullWidth>
                <InputLabel id="printer-select-label">Printer</InputLabel>
                <Select labelId="printer-select-label" value={tmpState || ''} label="Printer" onChange={(e) => setTmpState(e.target.value)}>
                  <MenuItem value="FlexiPressPrinter">FlexiPress</MenuItem>
                  <MenuItem value="RotoPressPrinter">RotoPress</MenuItem>
                  <MenuItem value="CutSawPrinter">CutSaw</MenuItem>
                </Select>
              </FormControl>
            </div>
          );
        },
        onSave: (currentItemState, dispatch, closeFn, tmpState) => {
          dispatch(backendCall(null, '/api/v1/orders/bsh/print_sticker/', 'POST', { ...currentItemState, printer: tmpState }));
        },
        title: modelFieldMessages.selectPrinter
      }
    },
    showBSHOrderPanel: {
      adminRequired: false,
      key: 'showBSHOrderPanel',
      format: {
        type: 'action',
        icon: 'info',
        style: { fontSize: '27px', color: 'black' }
      },
      title: modelFieldMessages.orderInfo
    }
  };
}

export default BSHOrder;
